import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { withSearchHandler } from 'decorators';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { withExperiment } from '@sparefoot/react-core/decorators';
import { getPaidLandingViewPixel } from '@sparefoot/react-core/utils/tracking';
import { mapDispatchToActions } from '@sparefoot/react-core/utils';

import { getTollfreePhoneNumber } from 'store/modules/phone';
import marketingSelector from 'store/selectors/marketing';

import stepsCards from 'config/stepsCards';
import { PLPReviews } from 'config/reviews';
import { phonePropType } from 'config/propTypes';

import { Page } from 'components/core/Page';
import { TrustPilotReviewSection } from 'components/landing';
import { MarketingFooter } from 'components/landing/MarketingFooter';
import { StickySearch } from 'components/search/StickySearch';
import { MarketingHero } from 'components/landing/MarketingHero';
import { MarketingSimpleSteps } from 'components/landing/MarketingSimpleSteps';
import { MarketingPartners } from 'components/landing/MarketingPartners';
import { withPageViewTracking } from 'components/core/library/tracking-utils';

import './MarketingLandingPage.scss';
import { PAGE_TYPES } from '@sparefoot/tracking-events';

export const enhance = compose(
	withProps(() => ({ trackingPixel: getPaidLandingViewPixel('toplvl') })),
	withSearchHandler,
	withExperiment('sf_14850_hero_promo_test_ssdc'),
	withExperiment('sf_15731_plp_refactor_ssdc'),
	connect(
		marketingSelector,
		{ getTollfreePhoneNumber },
		mapDispatchToActions,
	),
	withPageViewTracking(PAGE_TYPES.PPC),
);

export function MarketingLandingPage({
	additionalSearchParams,
	handleSearch,
	trackingPixel,
	sf14850Variation,
	phone,
	actions,
}) {
	return (
		<Page
			className={classnames('marketing-landing-page')}
			landingPage
			marketingPage
			trackingPixel={trackingPixel}
			pageType={PAGE_TYPES.PPC}
			noIndex
			noFollow
		>
			<MarketingHero
				sf14850Variation={sf14850Variation}
				onSearch={handleSearch}
				phone={phone}
				getTollfreePhoneNumber={actions.getTollfreePhoneNumber}
			/>
			<StickySearch
				hidden
				horizontal
				additionalSearchParams={additionalSearchParams}
				onSearch={handleSearch}
				callToBook
				phone={phone}
				getTollfreePhoneNumber={actions.getTollfreePhoneNumber}
			/>
			<MarketingSimpleSteps stepsCards={stepsCards} />
			<TrustPilotReviewSection
				customHeader
				isHomePage={false}
				reviews={PLPReviews}
				className="marketing-reviews"
			/>
			<MarketingPartners />
			<MarketingFooter className="blue-marketing-footer" />
		</Page>
	);
}

MarketingLandingPage.propTypes = {
	actions: PropTypes.shape({
		getTollfreePhoneNumber: PropTypes.func.isRequired,
	}).isRequired,
	additionalSearchParams: PropTypes.object,
	handleSearch: PropTypes.func.isRequired,
	phone: phonePropType,
	trackingPixel: PropTypes.string.isRequired,
	sf14850Variation: PropTypes.string,
};

export default enhance(MarketingLandingPage);
